module.exports = __webpack_public_path__ + "static/media/Innovative Teaching learning Microcontroller 2021-22.ec46ba76.pdf";